const languageButton = document.querySelector('#language-switcher');

/**
 * Lida com o disparo de click para abrir o dropdown de linguagem
 */
function handlerLanguageSwitcher() {
  const languageArrow = document.querySelector('.chevron');
  const dropdownLanguage = document.querySelector('.language-dropdown');
  if (!languageArrow.classList.contains('chevron-open')) {
    languageArrow.classList.add('chevron-open');
    dropdownLanguage.classList.add('dropdown-open');
  } else {
    languageArrow.classList.remove('chevron-open');
    dropdownLanguage.classList.remove('dropdown-open');
  }
}

/**
 * Aplicando os listener no elemento de linguagem que abre
 * o dropdown para selecionar a linguagem
 */
function applyListenerLanguageSwitcher() {
  if(languageButton){
    languageButton.addEventListener('click', handlerLanguageSwitcher);
  }
}

exports.init = applyListenerLanguageSwitcher;